import { Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Modal from "./Modal.component";
import Scaling from "../Scaling.component";

import { ReactComponent as ScaleInIcon } from "../Icons/scalein.svg";
import { ReactComponent as ScaleOutIcon } from "../Icons/scaleout.svg";
import { ReactComponent as Plus } from "../Icons/plus.svg";
import { ReactComponent as EditIcon } from "../Icons/pencil2.svg";
import { ReactComponent as TrashIcon } from "../Icons/trash.svg";

import AddTrade from "../AddTrade.component";
import ConfirmDelete from "./ConfirmDelete.component";
import { useDeleteTrade } from "../../hooks/useDeleteTrade";
import { useEffect, useState } from "react";
import TableHead from "../TableHead.component";
import { getCommonKeys } from "../../utils/alertsUtils";

const headerKeys = [
  { lable: "Ticker", name: "ticker", sortable: true },
  { lable: "Trade Date", name: "tradeDate", sortable: true },
  { lable: "Entry price", name: "entryPrice", sortable: true },
  { lable: "Quantity", name: "quantity", sortable: true },
  { lable: "Trade type", name: "tradeType", sortable: true },
  { lable: "Net profit/loss", name: "profit", sortable: true },
  { lable: "Trade rationale", name: "tradeRationale", sortable: false },
  { lable: "Actions", name: "actions", sortable: false },
];

function TradesTable({ trades, type, setSort, setOrder, order }) {
  const { isDeleting, deleteTrade } = useDeleteTrade();
  const [commonKeys, setCommonKeys] = useState([]);

  useEffect(() => {
    setCommonKeys(getCommonKeys(trades));
  }, [trades]);

  return (
    <Table striped bordered className="w-100">
      <TableHead order={order} setOrder={setOrder} setSort={setSort} commonKeys={commonKeys} headerKeys={headerKeys} />

      <tbody>
        {trades?.map((item, i) => (
          <tr key={i}>
            <td className="fw-bold">
              <Link to={`/trade-journal/trade-ticker/${item.ticker}`}>{item.ticker}</Link>
            </td>

            <td>{item.tradeDate.split("T")[0]}</td>
            <td>{item.entryPrice}</td>
            <td>{item.quantity}</td>
            <td>{item.tradeType}</td>
            <td className={item.profit < 0 ? "text-danger" : "text-success"}>{parseInt(item.profit.toFixed(2))}</td>
            <td>{item.tradeRationale}</td>
            <td className="d-flex justify-content-center gap-2">
              <Link to={`/trade-journal/${item._id}`}>
                <Button variant="outline-success" size="sm">
                  <Plus />
                </Button>
              </Link>

              <Modal>
                <Modal.Open opens="scale-in">
                  <Button variant="outline-success" size="sm">
                    <ScaleInIcon />
                  </Button>
                </Modal.Open>
                <Modal.Window name="scale-in">
                  <Scaling tradeId={item._id} ticker={item.ticker} type="Scale In" />
                </Modal.Window>
              </Modal>
              <Modal>
                <Modal.Open opens="scale-out">
                  <Button disabled={item.quantity === 0} variant="outline-danger" size="sm">
                    <ScaleOutIcon />
                  </Button>
                </Modal.Open>
                <Modal.Window name="scale-out">
                  <Scaling type="Scale Out" tradeId={item._id} ticker={item.ticker} />
                </Modal.Window>
              </Modal>
              <Modal>
                <Modal.Open opens="Edit-Trade">
                  <Button variant="outline-secondary" size="sm">
                    <EditIcon />
                  </Button>
                </Modal.Open>
                <Modal.Window name="Edit-Trade">
                  <AddTrade tradeToEdit={item} />
                </Modal.Window>
              </Modal>
              <Modal>
                <Modal.Open opens="Delete-Trade">
                  <Button variant="outline-danger" size="sm">
                    <TrashIcon />
                  </Button>
                </Modal.Open>
                <Modal.Window name="Delete-Trade">
                  <ConfirmDelete
                    resourceName={item.ticker}
                    onConfirm={() => deleteTrade(item._id)}
                    disabled={isDeleting}
                  />
                </Modal.Window>
              </Modal>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default TradesTable;
